import React from 'react';

const SubHeading = (props) => {
  return (
    <div className="contact-subheading">
      <h3>{props.Heading}</h3>
    </div>
  );
};

export default SubHeading;
